export default {
  CREATED_ON: `Created on {{ date }} by {{ name }}`,
  APPROVED_ON: `Approved on {{ date }} by {{ name }}`,
  ACKNOWLEDGED_ON: `Acknowledged on {{ date }} by {{ name }}`,
  JUSTIFIED_ON: `Marked as justified on {{ date }} by {{ name }}`,
  UNJUSTIFIED_ON: `Marked as unjustified on {{ date }} by {{ name }}`,
  REFUSED_ON: `Refused on {{ date }} by {{ name }}`,
  CANCELLED_ON: `Cancelled on {{ date }} by {{ name }}`,
  MISSING_DATE: `Missing date`
}
